import req from './request'
let methodStr = 'get'
export let dictApi = (url) => {
  return req({
    url: url,
    method: methodStr
  }).then(res => {
   return res.data.dt.dictValueList
  });
}



// WEBPACK FOOTER //
// ./src/utils/DictApi.js